import React from 'react';
import get from 'lodash/get';

import {
    TableHeader,
    TableRow,
    TableCell,
    HorseName,
    HorseTip,
} from './styled';

import useHorseTips from 'features/HorseTips/useHorseTips';
import HorseVideosSlider from 'features/HorseTips/HorseVideosSlider';

import { Table, TableContent } from 'ui/Table';
import Text from 'ui/Text';
import Wrapper from 'ui/Wrapper.tsx';

import { PRODUCTS_NAMES } from 'configs/products.ts';

const getHorseName = (race, horseNumber) =>
    get(race, ['starts', horseNumber - 1, 'horse', 'horseNameAndNationality']);

const getTitle = (trackName, productId, raceIndex) =>
    `${PRODUCTS_NAMES[productId]}-${raceIndex + 1} ${trackName} spiltips`;

const HorseTips = ({ raceIndex, race }) => {
    const { horseTips, videos, trackName, productId } = useHorseTips();
    const horseTipsByRace = horseTips[raceIndex] || [];

    const videosByRace = videos.filter(
        (video) => Number(video.raceNumber) === raceIndex + 1
    );

    return (
        <>
            {horseTipsByRace.length > 0 && (
                <Table>
                    <TableHeader>
                        <Text bold white size="16px">
                            {getTitle(trackName, productId, raceIndex)}
                        </Text>
                    </TableHeader>
                    <TableContent>
                        {horseTipsByRace.map(({ horseNumber, description }) => (
                            <TableRow>
                                <TableCell>
                                    <HorseName>{horseNumber}.</HorseName>
                                </TableCell>
                                <TableCell>
                                    <HorseName>
                                        {getHorseName(race, horseNumber)}{' '}
                                    </HorseName>
                                    <HorseTip
                                        dangerouslySetInnerHTML={{
                                            __html: description,
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableContent>
                </Table>
            )}

            {videosByRace.length > 0 && (
                <Wrapper margin="15px 0 0" padding="0">
                    <HorseVideosSlider videos={videosByRace} />
                </Wrapper>
            )}
        </>
    );
};

export default HorseTips;
